<form>
    <label class="toggle-switch clearfix">
        <span class="togggle-switch-label left font-size--1">Create a seperate layer for each graphic</span>
        <input type="checkbox" name="seperate" class="toggle-switch-input" [(ngModel)]="createLayerForEachGraphic" checked>
        <span class="toggle-switch-track right"></span>
    </label>
    <div class="setting">
        <label for="text-input">Text input</label>
        <input id="text-input" type="text" name="textInput" [(ngModel)]="symbolProperties.text"
            placeholder="Enter Text...">
    </div>
    <div class="setting">
        <label for="font-family">Font</label>
        <select id="font-family" class="" name="font" [(ngModel)]="symbolProperties.font.family" (change)="fontFamilyChanged()">
            <option *ngFor="let option of fontFamilies" [value]="option">{{ option }}</option>
        </select>
    </div>
    <div class="setting">
        <label for="horizontal-alignment">Horizontal Alignment</label>
        <select id="horizontal-alignment" class="select-full " name="horizontalAlignment"
            [(ngModel)]="symbolProperties.horizontalAlignment">
            <option *ngFor="let option of horizontalAlignmentOptions" [value]="option">{{ option }}</option>
        </select>
    </div>

    <div class="setting">
        <label for="vertical-alignment">Vertical Alignment</label>
        <select id="vertical-alignment" class="select-full " name="verticalAlignment"
            [(ngModel)]="symbolProperties.verticalAlignment">
            <option *ngFor="let option of verticalAlignmentOptions" [value]="option">{{ option }}</option>
        </select>
    </div>

    <div class="setting">
        <label for="font-size">Font Size</label>
        <select id="font-size" class="select-full " name="size" [(ngModel)]="symbolProperties.font.size">
            <option *ngFor="let option of fontSizeOptions" value="{{option + 'px'}}">{{ option }}</option>
        </select>
    </div>

    <div class="setting">
        <label for="color" (click)="colorPicker.showColorPicker = true;">Font Color</label>
        <mc-color-picker-ng #colorPicker [(color)]="symbolProperties.color"></mc-color-picker-ng>
    </div>

    <div class="setting">
        <label>Font Style</label>
        <div class="btn-group">
            <button class="btn btn-grouped" [disabled]="boldDisabled" [ngClass]="{'btn-clear': symbolProperties.font.weight === 'bold'}" (click)="toggleBold();" title="Bold" style="font-weight: bold;">B</button>
            <button class="btn btn-grouped" [disabled]="italicDisabled" [ngClass]="{'btn-clear': symbolProperties.font.style === 'italic'}" (click)="toggleItalic();" title="Italic" style="font-style: italic;">I</button>
            <button class="btn btn-grouped" [ngClass]="{'btn-clear': symbolProperties.font.decoration === 'underline'}" (click)="toggleUnderline();" title="Underline">_</button>
        </div>
    </div>
</form>
